import { nullable, object, string, union } from "@scalar/validation";
//#region src/entities/registry/document.ts
var registryApiMetadata = object({
	id: string(),
	title: string(),
	namespace: string(),
	currentVersion: string(),
	logoUrl: union([string(), nullable()]),
	slug: string()
});
//#endregion
export { registryApiMetadata };

//# sourceMappingURL=document.js.map